import { mapGetters } from 'vuex'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'

const showChannnelsMixin = {
  data () {
    return {
      isBottom: false
    }
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('auth', ['hasRole']),
    ...mapGetters('profile', {
      foundryLoading: ['loadingFoundrySpinner'],
      foundries: ['foundries']
    }),
    showSubmission () {
      return this.isAllReadyStatesComplete()
    },
    showChannnels () {
      let valid = this.isAllValid() && (this.getUserRoles(this.user) !== 'foundrySupport')
      let checkFoundry = this.foundries.filter(item => item.id === this.submissionFoundryId)
      let isPIM = checkFoundry.length > 0 ? checkFoundry[0].isFontDataInPIM === 'Yes' : false
      return isPIM && valid
    }
  },

  watch: {
    submissionLimitError (newValue, oldValue) {
      this.isBottom = !oldValue && newValue
    }
  },

  updated () {
    if (this.submissionLimitError && this.isBottom) {
      window.scrollTo(0, document.body.scrollHeight)
      if (document.body.scrollHeight > 1000) {
        this.isBottom = false
      }
    }
  }
}

export default showChannnelsMixin
